import React from "react"
import { Link } from "components/Link"

import { blogSlug } from "components/Blog/utils/Blog.utils"
import { colors } from "lib/theme"
import { preventWidow } from "utils/preventWidow"

import { container, breadcrumbContainer } from "./Breadcrumb.css"

type Props = {
  title: string
  slug: string
  slugPrefix: string
}

export const Breadcrumb: React.FC<Props> = ({ title, slug, slugPrefix }) => (
  <div className={container}>
    <div className={breadcrumbContainer}>
      <Link
        variant="acuminRegular"
        fontSize="1rem"
        color={colors.contentTertiary}
        href={blogSlug}
        title="BEAUTY PIE Blog"
      >
        Blog
      </Link>
      <p>/</p>
      <Link
        variant="acuminRegular"
        fontSize="1rem"
        href={`${blogSlug}/${slugPrefix}/${slug}`}
        title={title}
        dangerouslySetInnerHTML={preventWidow(title)}
      />
    </div>
  </div>
)
